import { JsonProperty } from "../../../models/utilities/json-property";
import { UnplannedMetric } from "./unplanned-task-metric";

export class UnplannedPickupMetricsGroupDto {

    public dealerId : string = '';

    public dealerName : string = '';

    public shipmentMethod : number = 1;

    public shipToAddressId : number|undefined = undefined;

    public shipToAddress : string|undefined = undefined;

    public name : string = '';

    public groupId : number = 0;

    @JsonProperty({  toClass: UnplannedMetric, designType: 'array' })
    public metrics : UnplannedMetric[] = [];

}
